import { gql } from '@apollo/client'

import { useQuery } from 'hooks'

const FORM_SUBMISSION_DETAIL_QUERY = gql`
  query FormSubmissionDetail($formSubmissionId: Long!) {
    formSubmission(id: $formSubmissionId) {
      id
      score
      dateCreated
      dimensionScores {
        score
        dimension {
          id
          name
          scale
        }
      }
      form {
        name
      }
      answers {
        normalizedValue
        question {
          id
          text
          type
          associatedLink
          normalizedThreshold
          dimension {
            id
          }
        }
        value {
          type
          bool
          number
          options {
            id
            value
          }
          notApplicable
        }
        recommendation {
          above
          bellow
          stage {
            scale
          }
        }
      }
      user {
        entity {
          projects {
            name
            stage {
              name
            }
            sectors {
              name
            }
          }
        }
      }
    }
  }
`

export const useFormSubmissionDetailQuery = (formSubmissionId, opts) =>
  useQuery(FORM_SUBMISSION_DETAIL_QUERY, opts, { formSubmissionId })
